import { render, staticRenderFns } from "./EcSpinner.vue?vue&type=template&id=2427e744&scoped=true"
import script from "./EcSpinner.vue?vue&type=script&lang=js"
export * from "./EcSpinner.vue?vue&type=script&lang=js"
import style0 from "./EcSpinner.vue?vue&type=style&index=0&id=2427e744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2427e744",
  null
  
)

export default component.exports